/**
 * Function to return a pair of arrays: items and emptyItems
 * @param {Object[]} items items to map
 * @param {Function} callback callback function to return both the component and empty component
 * @returns {Object[]} pair of component arrays for both items and empty items
 */
export const getComponentItems = (items, callback) => {
  return items.reduce(
    ([componentItems, emptyComponentItems], item, index) => {
      const [Component, EmptyComponent] = callback(item, index);

      return [
        [...componentItems, Component],
        [...emptyComponentItems, EmptyComponent],
      ];
    },
    [[], []],
  );
};
